var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-shower-head",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 4 2.5 2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5a4.95 4.95 0 0 0-7 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5 5 15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17v.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16v.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13v.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10v.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20v.01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14v.01"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11v.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.575e7e8ededb2f1fd0edfa6a6ce18cfe.svg";
export { ForwardRef as ReactComponent };